import React from 'react';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import { List, ListItem, ListItemButton, ListItemText } from '@mui/material';


export default function VENewComponentDialog(props) {

    const componentsBaseURL = "https://cdn.json2video.com/data/components";
    const thumbnailsBaseURL = "https://assets.json2video.com/assets/components/catalog";

    const [openDialog, setOpenDialog] = React.useState(false);

    const [catalogSections, setCatalogSections] = React.useState([]);
    const [selectedSection, setSelectedSection] = React.useState(null);
    const [allItems, setAllItems] = React.useState([]);
    const [listedItems, setListedItems] = React.useState([]);
    const [selectedItem, setSelectedItem] = React.useState(null);

    // Run once in the beginning
    React.useEffect(() => {
        async function loadData() {
            let section = null;

            // load the components catalog
            
            const catalogData = await fetch(`${componentsBaseURL}/catalog/index.json`)
                .then(r => r.json())
                .catch(e => {
                    console.log("Could not load components catalog");
                    return null;
                });

            if (catalogData) {
                // keep the sections
                if (Array.isArray(catalogData.sections)) {
                    console.log("catalogData.sections: ", catalogData.sections);
                    setCatalogSections(catalogData.sections);
                    if (catalogData.sections.length > 0) {
                        setSelectedSection(catalogData.sections[0]);
                        section = catalogData.sections[0];
                    }
                }
                
                // keep the items
                if (Array.isArray(catalogData.items)) {
                    console.log("catalogData.items: ", catalogData.items);
                    setAllItems(catalogData.items);
                    if (section) changeSection(section);
                }
            }

            setOpenDialog(true);
        }
        
        loadData();

    }, []);

    if (props.elementType === "component") return componentDialog();
    else return textDialog();
    

    function componentDialog() {
        return (
            <Dialog
                open={openDialog}
                onClose={handleCancel}
                fullWidth={true} maxWidth="md" scroll="paper"
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    <span className="font-bold">Choose a component template</span>
                </DialogTitle>
                <Box className="p-0 border-t border-b">
                    <Box className="flex h-96 overflow-hidden">
                        <Box className="w-48 h-full shrink-0 overflow-y-auto">
                            {
                                catalogSections.map((section, index) => (
                                    <Box className={(selectedSection?.id === section.id ? "bg-yellow-200 px-5 py-3 cursor-pointer" : "px-5 py-3 cursor-pointer")} key={section.id} onClick={() => changeSection(section)}>
                                        {section.name}
                                    </Box>
                                ))
                            }
                        </Box>
                        <Box className="h-full grow overflow-y-auto flex flex-wrap items-start justify-evenly">
                            {
                                allItems.filter(item => item.sections.includes(selectedSection.id)).map((item, index) => videoThumbnail(item))
                            }
                        </Box>
                    </Box>
                </Box>
                <DialogActions>
                    <Button onClick={handleCancel}>Cancel</Button>
                </DialogActions>
            </Dialog>
        );
    }

    function textDialog() {
        return (
            <Dialog
                open={openDialog}
                onClose={handleCancel}
                fullWidth={true} maxWidth="sm" scroll="paper"
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    <span className="font-bold">Choose a text style</span>
                </DialogTitle>
                <Box className="p-0 border-t border-b flex flex-wrap h-96 overflow-y-auto items-start justify-evenly">
                    {
                        allItems.filter(item => item.sections.includes("text")).map((item, index) => videoThumbnail(item))
                    }
                </Box>
                <DialogActions>
                    <Button onClick={handleCancel}>Cancel</Button>
                </DialogActions>
            </Dialog>
        );
    }

    function handleCancel(event) {
        props.onClose(null);
    }

    async function addComponent(selectedItem) {
        console.log("Add: ", selectedItem);
        setOpenDialog(false);

        const exampleJSON = 
            await fetch(`${componentsBaseURL}/catalog/${selectedItem.id}.json`)
                .then(r => r.json())
                .catch(e => {
                    console.log("Could not load example JSON");
                    return null;
                });

        props.onClose(exampleJSON?.component);
    }

    function changeSection(section) {
        console.log("changeSection(): ", section);
        setSelectedSection(section);
        setListedItems(allItems.filter(item => item.sections.includes(section.id)));
    }

    function videoThumbnail(item) {
        return (
            <Box className="bg-slate-100 m-5 rounded-md overflow-hidden relative cursor-pointer" key={item.id} onClick={() => addComponent(item)}>
                <video id={`component-${item.id}`} width={250} height={168} loop
                    poster={`${thumbnailsBaseURL}/${item.id}.jpg`}
                    onMouseOver={event => event.target.play()}
                    onMouseOut={event => event.target.pause()}>
                    <source src={`${thumbnailsBaseURL}/${item.id}.mp4`} type="video/mp4"/>
                    Your browser does not support the video tag.
                </video>
                <Box className="h-8 flex items-center justify-center text-gray-600">
                    <span>{item.name}</span>
                </Box>
            </Box>
        );
    }
}